import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CorporateAccountService, GeneralService, IUser } from '@clooper/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { noPastDateValidator, endDateAfterStartDateValidator } from '../../pages/assisted-booking/validator';
@Component({
  selector: 'app-extra-service-car',
  templateUrl: './extra-service-car.component.html',
  styleUrls: ['./extra-service-car.component.scss']
})
export class ExtraServiceCarComponent implements OnInit {
  user: IUser | undefined
  private toastState = {
  startPast: false,
  endPast: false,
  endBeforeStart: false
};
  form = new FormGroup({
    pickup_location: new FormControl('', [Validators.required]),
    drop_off_location: new FormControl('', [Validators.required]),
    rental_start_date: new FormControl('', [Validators.required, noPastDateValidator()]),
    rental_end_date: new FormControl('', [Validators.required, noPastDateValidator()]),
    additional_requests: new FormControl('', []),
    car_type: new FormControl('', [Validators.required]),
  },
         {
            validators: endDateAfterStartDateValidator('rental_start_date', 'rental_end_date')
          });
  locationName: any;
  booking: any;

  loading: boolean = false
  minDate: string;
  endDate: any;

  constructor(
    public bsModalRef: BsModalRef,
    private options: ModalOptions,
    private service: CorporateAccountService,
    private toastr: ToastrService,
    private gs: GeneralService,

  ) { }

  ngOnInit(): void {
    this.user = this.options.initialState?.user as IUser
    this.booking = this.options.initialState?.booking
      const ctrlStart = this.form.get('rental_start_date');
    const ctrlEnd = this.form.get('rental_end_date');

    ctrlStart?.valueChanges.subscribe(() => {
      if (ctrlStart.hasError('pastDate')) {
        if (!this.toastState.startPast) {
          this.toastr.error(
            'No past date allowed. Please enter the current date or a future date.'
          );
          this.toastState.startPast = true;
          this.form.get('rental_start_date')?.setValue('');
        }
      } else {
        this.toastState.startPast = false;
      }
    });
      ctrlEnd?.valueChanges.subscribe(() => {
    if (ctrlEnd.hasError('pastDate')) {
      if (!this.toastState.endPast) {
        this.toastr.error(
          'No past date allowed. Please enter today or a future date for End Date.'
        );
        this.toastState.endPast = true;
        this.form.get('rental_end_date')?.setValue('');
      }
    } else {
      this.toastState.endPast = false;
    }
      });
     this.form.valueChanges.subscribe(() => {
    if (this.form.hasError('endBeforeStart')) {
      if (!this.toastState.endBeforeStart) {
        this.toastr.error(
          'Rental end date cannot be earlier than the rental start date.'
        );
        this.toastState.endBeforeStart = true;
        this.form.get('rental_start_date')?.setValue('');
        this.form.get('rental_end_date')?.setValue('');
      }
    } else {
      this.toastState.endBeforeStart = false;
    }
  });
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0];
  }

  
  getDate(event: any) {
    this.endDate = event.value;
  }
  locationChangeF({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    console.log(s)
    this.form.controls.pickup_location.setValue(s);

  }

  locationChangeT({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.drop_off_location.setValue(s);

  }

  submit() {
    this.loading = true
    const {pickup_location, car_type, drop_off_location, additional_requests, rental_start_date, rental_end_date} = this.form.value;

    const payload = {
      pickup_location,
      drop_off_location,
      rental_start_date,
      rental_end_date,
      additional_requests,
      car_type,
      employee: this.user?.id || this.user?._id,
      business: this.user?.business?.id || this.user?.business?._id,
      booking: this.booking
    }
    if (this.booking !== null) {
      this.service.createExtraServiceCarRentals(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
        this.loading = false

        // this.bsModalRef.hide()
      })
    } else {
      delete payload.booking
      this.service.createExtraServiceCarRentals(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
        this.loading = false

        // this.bsModalRef.hide()
      })

    }
  }


}
